/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { MouseEvent, ReactElement, ReactNode } from 'react';

import { ChevronRightIcon } from 'elmo-elements';

import { sanitizeHTML } from '@/lib/util';

import './ChoiceOption.scss';

interface ChoiceOptionPropsType {
  /** Title of ChoiceOption */
  title?: string;
  /** On click event handler (optional, ChoiceOption can be used as a link) */
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  onMouseEnter?: (event: MouseEvent<HTMLAnchorElement>) => void;
  onMouseLeave?: (event: MouseEvent<HTMLAnchorElement>) => void;
  /** Icon of ChoiceOption */
  icon?: ReactNode;
  /** ChoiceOption description */
  description?: string;
  /** Wheather or not the ChoiceOption is disabled */
  isDisabled?: boolean;
  /** ChoiceOption id attribute, optional id */
  id?: string;
  /** ChoiceOption class name attribute, (optional) */
  className?: string;
  /** The href attribute is needed to use the component as a link (optional) */
  href?: string;
  /** tabIndex is for WCAG accessibility compliance (optional)  */
  tabIndex?: number;
  iconRight?: ReactNode;
}

const ChoiceOption = ({
  id,
  icon,
  title,
  description,
  className,
  isDisabled,
  href,
  tabIndex,
  iconRight,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: ChoiceOptionPropsType): ReactElement => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!isDisabled && onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  const handleMouseEnter = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!isDisabled && onMouseEnter) {
      event.preventDefault();
      onMouseEnter(event);
    }
  };

  const handleMouseLeave = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!isDisabled && onMouseLeave) {
      event.preventDefault();
      onMouseLeave(event);
    }
  };

  const purifiedHTML = (description &&
    (sanitizeHTML(description) as unknown)) as string;

  const classNamePrefix = 'elmoca-choiceoption';

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <a
      id={id}
      className={`${classNamePrefix} ${
        isDisabled && 'is-disabled'
      } ${className}`}
      {...(href ? { href } : {})}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={description}
      data-testid={`${classNamePrefix}-${id || 'default'}`}
      tabIndex={tabIndex || 0}
      role="button"
    >
      {icon && <div className={`${classNamePrefix}__icon`}>{icon}</div>}
      <div className={`${classNamePrefix}__content`}>
        <div className={`${classNamePrefix}__title`}>{title}</div>
        {purifiedHTML && (
          <div
            className={`${classNamePrefix}__description`}
            dangerouslySetInnerHTML={{
              __html: purifiedHTML,
            }}
            title={purifiedHTML}
          />
        )}
      </div>
      {iconRight && (
        <div className={`${classNamePrefix}__arrow`}>{iconRight}</div>
      )}
    </a>
  );
};

ChoiceOption.defaultProps = {
  iconRight: <ChevronRightIcon />,
};

export default ChoiceOption;
